import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const ServiceContract = ({ serviceContract }: SpecProps<"service_contract">) => {
  const { i18n } = useLingui();

  if (serviceContract === undefined) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.serviceContract",
    message: "Service contract",
    comment: "Label for 'Service contract'",
  });

  return <FieldValuePair field={field} value={serviceContract} />;
};
